// Knapp för en signerad Flatbox-faktura i LagbasN.
// Användning: <TimeFlowButton input={toTimeFlowInput(faktura)} />
import { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { copyTimeFlowPayload } from '../lib/timeflowExport';

const TIMEFLOW_URL = 'https://tikab.millnet.cloud/time/#/admin/project/project';

export default function TimeFlowButton({ input, disabled }) {
  const [status, setStatus] = useState(null);

  async function handleClick() {
    try {
      await copyTimeFlowPayload(input);
      setStatus({ ok: true, text: 'Kopierat. Time Flow öppnas – klicka på bokmärket "Flatbox → Time Flow" och välj "Läs från urklipp".' });
      window.open(TIMEFLOW_URL, 'timeflow');
    } catch (e) {
      setStatus({ ok: false, text: e.message });
    }
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
      <Button size="small" variant="outlined" startIcon={<OpenInNewIcon />} onClick={handleClick} disabled={disabled}>
        Skapa i Time Flow
      </Button>
      {status && (
        <Typography variant="caption" color={status.ok ? 'success.main' : 'error.main'}>{status.text}</Typography>
      )}
    </Box>
  );
}
